import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";

const ModalContacto = ({ show, onClose, empresa }) => {
  return (
    <Dialog open={show} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{empresa?.nombre_empresa || "Empresa desconocida"}</DialogTitle>
        </DialogHeader>

        <div className="space-y-3 text-sm">
          {/* Página Web */}
          {empresa?.pagina_web ? (
            (() => {
              let url = empresa.pagina_web.trim(); // ✅ Eliminar espacios en blanco

              // ✅ Agregar "https://" si no lo tiene
              if (!url.startsWith("http://") && !url.startsWith("https://")) {
                url = `https://${url}`;
              }

              // ✅ Agregar "www." si no lo tiene y si es un dominio de segundo nivel
              try {
                const urlObj = new URL(url);
                if (
                  !urlObj.hostname.startsWith("www.") &&
                  urlObj.hostname.split(".").length === 2
                ) {
                  url = url.replace("//", "//www.");
                }
              } catch (error) {
                console.error("URL inválida:", empresa.pagina_web);
              }

              return (
                <p>
                  <strong className="text-foreground">Página Web:</strong>{" "}
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    {empresa.pagina_web}
                  </a>
                </p>
              );
            })()
          ) : (
            <p>
              <strong className="text-foreground">Página Web:</strong>{" "}
              <i className="text-muted-foreground">No disponible</i>
            </p>
          )}

          {/* Dirección */}
          {empresa?.direccion ? (
            <p>
              <strong className="text-foreground">Dirección legal:</strong> {empresa.direccion}
            </p>
          ) : (
            <p>
              <strong className="text-foreground">Dirección legal:</strong>{" "}
              <i className="text-muted-foreground">No disponible</i>
            </p>
          )}

          {/* Teléfono */}
          {empresa?.telefono_empresa ? (
            <p>
              <strong className="text-foreground">Teléfono de la empresa:</strong>{" "}
              {empresa?.telefono_empresa}
            </p>
          ) : (
            <p>
              <strong className="text-foreground">Teléfono de la empresa:</strong>{" "}
              <i className="text-muted-foreground">No disponible</i>
            </p>
          )}

          {/* Información de Contacto */}
          <div>
            <p>
              <strong className="text-foreground">Datos de Contacto:</strong>
            </p>
            {Array.isArray(empresa?.informacion_contacto) &&
            empresa.informacion_contacto.length > 0 ? (
              <ul className="mt-1 list-disc space-y-1 pl-5">
                {empresa.informacion_contacto.map((contacto, index) => (
                  <li key={index}>
                    <strong className="text-foreground">{contacto.nombre}:</strong>{" "}
                    {contacto.telefono} | {contacto.email}
                  </li>
                ))}
              </ul>
            ) : (
              <p>
                <i className="text-muted-foreground">No hay información de contacto disponible</i>
              </p>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModalContacto;
